export default __webpack_public_path__ + "static/media/main.a6272385.jpg";